import { css, keyframes } from '@emotion/react';

export const shine = keyframes`
  to {
    background-position: 200% center;
  }
`;

export const helperLoadingText = () => {
  return css`
    background-image: linear-gradient(270deg, #ebebeb 0%, currentColor 50%, #ebebeb 100%);
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${shine} 1s linear infinite;
  `;
};
